import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface AuthBanner {
  title?: string | null;
  offer_1?: string | null;
  offer_2?: string | null;
  crossSellOffer_1?: string | null;
  crossSellOffer_2?: string | null;
  background?: CMSImageBase;
  characters?: CMSImageBase;
}

export interface AuthenticationBanners extends CMSApiBase {
  registrationV2: AuthBanner;
  login: AuthBanner;
}

export const authenticationBannersCMSV3 = (lang: string) =>
  request<AuthenticationBanners>({
    url: buildCmsUrl({ path: 'authentication-banners', lang }),
  });

export const authenticationBannersCMSV4 = (lang: string) =>
  request<AuthenticationBanners>({
    url: buildCmsUrl({
      path: 'authentication-banner',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<AuthenticationBanners>
    ),
  });

export const authenticationBannersCMS = isCMSV3
  ? authenticationBannersCMSV3
  : authenticationBannersCMSV4;
